import { inject, Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { SubDistrict, Address } from "../model/address.model";
import { UserModel } from "src/app/pages/auth";
import { Parent, Student } from "../model/student.model";
import { Role } from "src/utils/enum/role.enum";

@Injectable({ providedIn: "root" })
export class UserService {
  #http = inject(HttpClient);
  private excepted_key_names: string[] = [];

  private apiStudentUrl = "/students";
  private apiParentUrl = "/parents";
  _setFilter(obj: any) {
    return Object.fromEntries(
      Object.entries(obj).filter(([_, v]) => v != null)
    );
  }

  _setParams(value: any) {
    if (!value) return;
    const filter: any = this._setFilter(value);
    let params = new HttpParams();
    for (const key in filter) {
      if (Array.isArray(filter[key])) {
        params = params.append(key, JSON.stringify(filter[key]));
      } else {
        params = params.append(key, filter[key]);
      }
    }
    return params;
  }
  _setFormData(object_key: string, value: any) {
    let formData = new FormData();
    for (const key in value) {
      let obj = value[key];
      if (Array.isArray(obj)) {
        obj.forEach((e, i) => {
          if (this.excepted_key_names.includes(key)) {
            formData.append(`${object_key}[${key}][]`, e);
          } else {
            for (const key_i in e) {
              formData.append(`${object_key}[${key}][][${key_i}]`, e[key_i]);
            }
          }
        });
      } else {
        if (value[key]) {
          formData.append(`${object_key}[${key}]`, value[key]);
        }
      }
    }
    return formData;
  }

  updateUser(
    id: number,
    data: Student | Parent,
    user_type: Role = Role.MEMBER_EN
  ): Observable<Student | Parent> {
    let payload = this._setFormData(user_type, data);
    return this.#http.put<Student | Parent>(`/${user_type}s/${id}`, payload);
  }
  // updateParent(id: number, data: Parent): Observable<Parent> {
  //   let payload = this._setFormData("parent", data);
  //   return this.#http.put<Parent>(`${this.apiParentUrl}/${id}`, payload);
  // }

  getCodeInvitation(): Observable<any> {
    return this.#http.get(`/parent_invitations`);
  }

  changePassword(payload: any): Observable<any> {
    return this.#http.post(`/change_password`, payload);
  }

  requestToReset(value: any): Observable<any> {
    return this.#http.post(`/${"forgot_passwords"}`, {
      email: value,
    });
  }
  resetPassword(value: any): Observable<any> {
    return this.#http.post(`/${"forgot_passwords/reset_password"}`, value);
  }
}
